/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2020 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { getAssigneesProject } from '@builddocs/data-management'
import { useQuery } from 'react-query'

export function useAssigneesProjectQuery(projectId: string) {
  return useQuery({
    queryFn: () => getAssigneesProject(projectId),
    queryKey: ['project', 'assignees', projectId],
  })
}
